var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoligblokk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.997,
    height: 54,
    viewBox: "0 0 54.997 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(0.315 0.158)",
    fill: "#b7dc8f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boligblokk",
    transform: "translate(-114.003 -358)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-2",
    "data-name": "Ellipse 96",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(115 358)",
    fill: "#b7dc8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(113.688 357.842)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(9.993 11.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 16.147,
    height: 9.285,
    transform: "translate(11.291 0.963)",
    fill: "#58969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M34.5,2.529l-16.147.616V1.565H34.5Z",
    transform: "translate(-7.066 -0.602)",
    fill: "#4e7e83"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 1.168,
    height: 6.063,
    transform: "translate(14.085 2.542)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 0.727,
    height: 6.063,
    transform: "translate(15.253 2.542)",
    fill: "#2e5057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 1.168,
    height: 6.063,
    transform: "translate(18.417 2.542)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 0.727,
    height: 6.063,
    transform: "translate(19.585 2.542)",
    fill: "#2e5057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 1.168,
    height: 6.063,
    transform: "translate(23.027 2.574)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 0.727,
    height: 6.063,
    transform: "translate(24.194 2.574)",
    fill: "#2e5057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 5.922,
    height: 9.285,
    transform: "translate(5.369 0.963)",
    fill: "#2e575e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 21.878,
    height: 33.972,
    transform: "translate(11.373 8.448)",
    fill: "#58969f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 0.796,
    height: 33.972,
    transform: "translate(11.373 8.448)",
    fill: "#66adb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M47.928,50.217H43.382V20.57l5.257-.316Z",
    transform: "translate(-16.698 -7.796)",
    fill: "#66adb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M37.456,50.217H32.909V20.57l5.257-.316Z",
    transform: "translate(-12.667 -7.796)",
    fill: "#66adb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M26.637,50.217H22.089V20.57l5.258-.316Z",
    transform: "translate(-8.502 -7.796)",
    fill: "#66adb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 10.168,
    height: 33.972,
    transform: "translate(1.205 8.448)",
    fill: "#2e575e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 3.694,
    height: 28.826,
    transform: "translate(14.368 13.594)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 0.915,
    height: 28.826,
    transform: "translate(17.146 13.594)",
    fill: "#2b424d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 2.778,
    height: 6.566,
    transform: "translate(14.368 14.321)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 2.778,
    height: 5.477,
    transform: "translate(14.368 14.865)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 2.493,
    height: 4.738,
    transform: "translate(14.368 15.195)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M23.359,27.5l2.494-1.615V24.7H24.54l-1.181.765Z",
    transform: "translate(-8.991 -9.509)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M25.853,28.315v-.9l-2.494,1.615v.9Z",
    transform: "translate(-8.991 -10.551)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 2.778,
    height: 6.566,
    transform: "translate(14.368 23.394)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 2.778,
    height: 5.477,
    transform: "translate(14.368 23.939)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 2.493,
    height: 4.738,
    transform: "translate(14.368 24.27)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M23.359,42.257l2.494-1.614V39.458H24.54l-1.181.765Z",
    transform: "translate(-8.991 -15.188)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M25.853,43.068v-.9L23.359,43.78v.9Z",
    transform: "translate(-8.991 -16.23)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 2.778,
    height: 6.566,
    transform: "translate(14.368 32.468)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 2.778,
    height: 5.477,
    transform: "translate(14.368 33.012)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 2.493,
    height: 4.738,
    transform: "translate(14.368 33.344)",
    fill: "#5eb0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M23.359,57.01l2.494-1.615V54.21H24.54l-1.181.765Z",
    transform: "translate(-8.991 -20.867)",
    fill: "#7dcecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M25.853,57.82v-.9l-2.494,1.615v.9Z",
    transform: "translate(-8.991 -21.909)",
    fill: "#7dcecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 3.695,
    height: 28.826,
    transform: "translate(20.737 13.594)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 0.915,
    height: 28.826,
    transform: "translate(23.516 13.594)",
    fill: "#2b424d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 2.778,
    height: 6.566,
    transform: "translate(20.737 14.321)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 2.778,
    height: 5.477,
    transform: "translate(20.737 14.865)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 2.494,
    height: 4.738,
    transform: "translate(20.737 15.195)",
    fill: "#5eb0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M33.714,27.5l2.494-1.615V24.7H34.9l-1.182.765Z",
    transform: "translate(-12.977 -9.509)",
    fill: "#7dcecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M36.208,28.315v-.9l-2.494,1.615v.9Z",
    transform: "translate(-12.977 -10.551)",
    fill: "#7dcecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 2.778,
    height: 6.566,
    transform: "translate(20.737 23.394)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 2.778,
    height: 5.477,
    transform: "translate(20.737 23.939)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 2.494,
    height: 4.738,
    transform: "translate(20.737 24.27)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M33.714,42.257l2.494-1.614V39.458H34.9l-1.182.765Z",
    transform: "translate(-12.977 -15.188)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M36.208,43.068v-.9L33.714,43.78v.9Z",
    transform: "translate(-12.977 -16.23)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 2.778,
    height: 6.566,
    transform: "translate(20.737 32.468)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 2.778,
    height: 5.477,
    transform: "translate(20.737 33.012)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 2.494,
    height: 4.738,
    transform: "translate(20.737 33.344)",
    fill: "#5eb0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M33.714,57.01l2.494-1.615V54.21H34.9l-1.182.765Z",
    transform: "translate(-12.977 -20.867)",
    fill: "#7dcecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M36.208,57.82v-.9l-2.494,1.615v.9Z",
    transform: "translate(-12.977 -21.909)",
    fill: "#7dcecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 3.695,
    height: 28.826,
    transform: "translate(27.107 13.594)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 0.915,
    height: 28.826,
    transform: "translate(29.885 13.594)",
    fill: "#2b424d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 2.778,
    height: 6.566,
    transform: "translate(27.107 14.321)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 2.778,
    height: 5.477,
    transform: "translate(27.107 14.865)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 2.494,
    height: 4.738,
    transform: "translate(27.107 15.195)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M44.07,27.5l2.493-1.615V24.7H45.25l-1.181.765Z",
    transform: "translate(-16.963 -9.509)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M46.562,28.315v-.9L44.07,29.027v.9Z",
    transform: "translate(-16.963 -10.551)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 2.778,
    height: 6.566,
    transform: "translate(27.107 23.394)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 2.778,
    height: 5.477,
    transform: "translate(27.107 23.939)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 2.494,
    height: 4.738,
    transform: "translate(27.107 24.27)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M44.07,42.257l2.493-1.614V39.458H45.25l-1.181.765Z",
    transform: "translate(-16.963 -15.188)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M46.562,43.068v-.9L44.07,43.78v.9Z",
    transform: "translate(-16.963 -16.23)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 2.778,
    height: 6.566,
    transform: "translate(27.107 32.468)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 2.778,
    height: 5.477,
    transform: "translate(27.107 33.012)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 2.494,
    height: 4.738,
    transform: "translate(27.107 33.344)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M44.07,57.01l2.493-1.615V54.21H45.25l-1.181.765Z",
    transform: "translate(-16.963 -20.867)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M46.562,57.82v-.9L44.07,58.533v.9Z",
    transform: "translate(-16.963 -21.909)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M18.358,17.949l21.959-2.624H18.439Z",
    transform: "translate(-7.066 -5.899)",
    fill: "#4e7e83"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 23.209,
    height: 1.925,
    transform: "translate(10.674 7.785)",
    fill: "#2e575e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 10.483,
    height: 1.925,
    transform: "translate(0 7.785)",
    fill: "#2e575e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 18.106,
    height: 1.927,
    transform: "translate(10.519)",
    fill: "#2e575e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 6.476,
    height: 1.927,
    transform: "translate(4.043)",
    fill: "#2e575e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 21.878,
    height: 3.315,
    transform: "translate(11.373 40.971)",
    fill: "#afb99f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 10.168,
    height: 3.315,
    transform: "translate(1.205 40.971)",
    fill: "#959781"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoligblokk);
export default __webpack_public_path__ + "static/media/Boligblokk.97658cf68878812b42e38e7468fc36d4.svg";
export { ForwardRef as ReactComponent };